import React, { useState } from 'react';
import { NamedLink } from '../../../../components';
import css from './Navbar.module.css';
import logoImg from "../../../../assets/logo.avif"
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={css.navbar}>
      <div className={css.navContainer}>
        <div className={css.logo} onClick={()=>window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={logoImg ||"/logo.avif" } alt="Logo" />
        </div>
        <ul className={css.navLinks}>
          <li>
            <NamedLink name="LandingPage" className={css.navLink}>
              INICIO
            </NamedLink>
          </li>
          <li>
            <NamedLink name="AboutPage" className={css.navLink}>
              QUIENES SOMOS
            </NamedLink>
          </li>
          <li>
            <NamedLink name="SearchPage" className={css.navLink}  to={{ search:"address=Espa%C3%B1a&bounds=28.08136788%2C-15.4942265%2C27.93951364%2C-15.62583784&mapSearch=true" }}
             >
              COMPRAR
            </NamedLink>
          </li>
          <li>
            <NamedLink name="RecipesPage" className={css.navLink}>
              RECETAS
            </NamedLink>
          </li>
          <li>
            <NamedLink name="ProfileSettingsPage" className={css.navLink}>
               ALTA/ACCESO USUARIOS
            </NamedLink>
          </li>
        </ul>

        <button 
          className={css.mobileMenuBtn}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className={`${css.hamburger} ${isMenuOpen ? css.active : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <div className={`${css.mobileMenu} ${isMenuOpen ? css.open : ''}`}>
          <ul className={css.mobileNavLinks}>
            <li>
              <NamedLink name="LandingPage" className={css.mobileNavLink} onClick={closeMenu}>
                INICIO
              </NamedLink>
            </li>
            <li>
              <NamedLink name="AboutPage" className={css.mobileNavLink} onClick={closeMenu}>
                QUIENES SOMOS
              </NamedLink>
            </li>
            <li>
              <NamedLink name="SearchPage" className={css.mobileNavLink} onClick={closeMenu} to={{ search:"address=Espa%C3%B1a&bounds=28.08136788%2C-15.4942265%2C27.93951364%2C-15.62583784&mapSearch=true" }}>
                COMPRAR
              </NamedLink>
            </li>
            <li>
              <NamedLink name="RecipesPage" className={css.mobileNavLink} onClick={closeMenu}>
                RECETAS
              </NamedLink>
            </li>
            
            <li>
              <NamedLink name="ProfileSettingsPage" className={css.mobileNavLink} onClick={closeMenu}>
                 ALTA/ ACCESO USUARIOS
              </NamedLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
